import { ApiConfig, tokenService, SportsDataApiClient, Format } from "sbtech-sports-data-api-client";
import { SportDataGatewayConfig } from "../../SportData";
import { GlobalConfig } from "../../configuration";
export { entities } from "sbtech-sports-data-api-client";
/**
 * SportDataGateway class provides interface for communication between sports data service and blocks though sports data client.
 */
export class SportDataGateway {
    /**
    * Creates an instance of SportDataGateway
    * SportsDataGatewayConfig should be initialized before this constructor
    **/
    constructor() {
        this.gatewayConfig = new SportDataGatewayConfig(GlobalConfig.apiConfigs.sportDataApiUrl);
        this.setAuthToken();
        this.client = new SportsDataApiClient(this.getApiConfig());
        this.format = GlobalConfig.isDebug ? Format.Json : Format.Msgpack;
    }
    setAuthToken() {
        this.gatewayConfig.authToken = GlobalConfig.getAuthorization().token;
        if (this.gatewayConfig.authToken) {
            tokenService.apiAccessToken = this.gatewayConfig.authToken;
        }
        ;
    }
    /**
     * Activate method does nothing and has beed added for consistency
    */
    activate() {
    }
    /**
     * Pulls data from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPayload>} queryInfo query sports data client
     * In case of pulling events from sportsData API you can get 2 arrays markets and events this
     * is why the Payload is diferent
    */
    pullEvents(queryInfo) {
        let query = this.getQuery(queryInfo);
        this.client.events.pull(query)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Pulls data from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<entities.Market[]>} queryInfo query sports data client
    */
    pullMarkets(queryInfo) {
        let query = this.getQuery(queryInfo);
        this.client.markets.pull(query)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Pulls data from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<entities.League[]>} queryInfo query sports data client
    */
    pullLeagues(queryInfo) {
        let query = this.getQuery(queryInfo);
        this.client.leagues.pull(query)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Pulls data from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<entities.Region[]>} queryInfo query sports data client
    */
    pullRegions(queryInfo) {
        let query = this.getQuery(queryInfo);
        this.client.regions.pull(query)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Pulls data from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<entities.Sport[]>} queryInfo query sports data client
    */
    pullSports(queryInfo) {
        let query = this.getQuery(queryInfo);
        this.client.sports.pull(query)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Pulls data from sports data API for entity of type "GameIncidets".
     * @param {PullGameIncidentsQueryInfo} queryInfo query sports data client
    */
    pullGameIncidents(queryInfo) {
        this.client.gameIncidents.pull(queryInfo.eventIds, queryInfo.incidentTypes, queryInfo.top, queryInfo.skip, this.format)
            .then(res => queryInfo.onMessageHandler(res.data))
            .catch(ex => queryInfo.onErrorHandler && queryInfo.onErrorHandler(ex));
    }
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Event".
     * @param {SportDataGatewayQueryInfo<EventPushResponse>} queryInfo query sports data client
    */
    subscribeForEvents(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.events.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Market".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Market, entities.MarketChange>>} queryInfo query sports data client
    */
    subscribeForMarkets(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.markets.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "League".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.League, entities.LeagueChange>>} queryInfo query sports data client
     */
    subscribeForLeagues(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.leagues.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Region".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Region, entities.RegionChange>>} queryInfo query sports data client
    */
    subscribeForRegions(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.regions.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * Subscribes for snapshots/updates from sports data API for entity of type "Sport".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Sport, entities.SportChange>>} queryInfo query sports data client
    */
    subscribeForSports(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.sports.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * @deprecated since sports data api client version [0.12.0] - 2019-08-01. Use pullGameIncidents and subscribeForGameIncidents endpoints.
     * Subscribe for snapshots/updates from sports data API for entity of type "Incidents".
     * @param {SportDataGatewayQueryInfo<EntityPushResponse<entities.Incident, entities.Incident>>} queryInfo query sports data client
     */
    subscribeForIncidents(queryInfo) {
        let query = this.getQuery(queryInfo);
        return this.client.incidents.subscribe(query, queryInfo.onMessageHandler, queryInfo.onErrorHandler);
    }
    /**
     * Subscribe for snapshots/updates from sports data API for entity of type "GameIncident".
     * @param {SubscribeGameIncidentsQueryInfo} queryInfo query sports data client
     */
    subscribeForGameIncidents(queryInfo) {
        return this.client.gameIncidents.subscribe(queryInfo.eventIds, queryInfo.onMessageHandler, queryInfo.onErrorHandler, queryInfo.incidentTypes);
    }
    getApiConfig() {
        let apiUrl = this.gatewayConfig.serviceUrl + this.gatewayConfig.apiEndpoint;
        return new ApiConfig(apiUrl);
    }
    getQuery(queryInfo) {
        let query = {
            query: queryInfo.query,
            locale: queryInfo.locale || GlobalConfig.apiConfigs.locale,
            format: this.format,
            params: {
                initialData: queryInfo.initialData,
                from: queryInfo.from,
                until: queryInfo.until,
                timeRange: queryInfo.timeRange,
                includeMarkets: queryInfo.includeMarkets,
                projection: queryInfo.projection,
                format: "ODataV3"
            }
        };
        return query;
    }
}
//# sourceMappingURL=SportDataGateway.js.map